import BaseApiController from 'controller/baseresourcecontroller';

export default class movebasketController extends BaseApiController {
    constructor() {
        super('mvc/MoveBasketDetail');
    }

    async GetDetail(autoid) {
        return super.Get(`GetDetail?moveBasketId=${autoid}`);
    }

    async GetDefault() {
        return super.Get('GetDefault');
    }

    async GetMoveBasketLines(autoid, search, pagesize = 10, pageindex = 0) {
        return super.Post('GetMoveBasketLines', {
            SearchKey: search,
            PageSize: pagesize,
            PageIndex: pageindex,
            MoveBasketID: autoid
        });
    }

    async GetMoveBasketLine(AutoID) {
        return super.Post('GetMoveBasketLine', {
            AutoID
        });
    }

    async Save(data) {
        return super.Post('Save', data);
    }
    async ProcessMoveBasket(data) {
        return super.Post('ProcessMoveBasket', data);
    }
    async GetSelectedObjects(data) {
        return super.Post('GetSelectedObjects', data);
    }
    async Delete(movebasketID) {
        return super.Post('Delete', { movebasketID });
    }
    async DeleteMoveBasketItem(movebasketID, objectID) {
        return super.Post('DeleteMoveBasketItem', { movebasketID, objectID });
    }
    async UpdateMoveBasketLine(movebasketID, MovebasketLineID, Quantity) {
        return super.Post('UpdateMoveBasketLine', { movebasketID, MovebasketLineID, Quantity });
    }
    async GetActiveMovebasketInfo() {
        return super.Post('GetActiveMovebasketInfo', null);
    }
    async GetRecentMoveBasketLines(MovebasketID) {
        return super.Post('GetRecentMoveBasketLines', { MovebasketID });
    }
    async GetSystemSettingReportDefinition() {
      return super.Post('GetSystemSettingReportDefinition');
    }
    async GetLocationOwner(locationid) {
      return super.Post('GetLocationOwner', { locationid });
    }
    async GetApplicableObjects(data) {
      return super.Post('GetApplicableObjects', data);
    }
    async MoveBasketCanBeProcessed(data) {
      return super.Post('MoveBasketCanBeProcessed', data);
    }
}
